export function getSearchPlaceholder(searchType, searchTypeOptions) {
  const option = searchTypeOptions.find((item) => item.value === searchType);

  if (searchType === "asin") {
    return "Search ASINs (comma separated)";
  }

  if (option?.inputType === "select" || option?.inputType === "multiSelect") {
    return option.placeholder ?? `Select ${option.label ?? "..."}`;
  }

  return `Search ${option?.label ?? "..."}`;
}

export function splitCommaSeparatedValues(value) {
  if (value == null || value === "") return [];

  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter((item) => item.length > 0);
}

export function getMultiSelectValues(value) {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  return splitCommaSeparatedValues(value);
}

export function getEmptyFilterValue(searchType, searchTypeOptions = []) {
  const option = searchTypeOptions.find((item) => item.value === searchType);
  return option?.inputType === "multiSelect" ? [] : "";
}

export function hasFilterRowValue(row, searchTypeOptions = []) {
  const option = searchTypeOptions.find((item) => item.value === row.searchType);

  if (option?.inputType === "multiSelect") {
    return getMultiSelectValues(row.value).length > 0;
  }

  return Boolean(String(row.value ?? "").trim());
}

export function serializeFilterRowValue(row, searchTypeOptions = []) {
  const option = searchTypeOptions.find((item) => item.value === row.searchType);

  if (option?.inputType === "multiSelect") {
    return getMultiSelectValues(row.value).join(",");
  }

  return String(row.value ?? "").trim();
}

export function getSearchInputConfig(searchType, searchTypeOptions = []) {
  return searchTypeOptions.find((option) => option.value === searchType) ?? null;
}

export function buildFiltersArray(filterItems = [], searchTypeOptions = []) {
  const result = [];

  filterItems.forEach((filter) => {
    const trimmed = filter.searchText?.trim();
    if (!trimmed || !filter.searchType) return;

    const searchConfig = searchTypeOptions.find(
      (option) => option.value === filter.searchType
    );
    if (!searchConfig) return;

    if (searchConfig.operator === "IN") {
      const values = splitCommaSeparatedValues(trimmed);

      if (!values.length) return;

      const normalizedValues =
        searchConfig.value === "status"
          ? values.map((value) => value.toUpperCase())
          : values;

      result.push({
        field_name: searchConfig.value,
        operator: "IN",
        values: normalizedValues,
      });
      return;
    }

    result.push({
      field_name: searchConfig.value,
      operator: searchConfig.operator,
      value:
        searchConfig.value === "status" ? trimmed.toUpperCase() : trimmed,
    });
  });

  return result;
}

export function getAvailableSearchTypeOptions(
  filterRows = [],
  searchTypeOptions = [],
  currentRowId
) {
  const usedByOtherRows = new Set(
    filterRows
      .filter((row) => row.id !== currentRowId)
      .map((row) => row.searchType)
  );

  return searchTypeOptions.filter(
    (option) => !usedByOtherRows.has(option.value)
  );
}

export function getNextAvailableSearchType(
  filterRows = [],
  searchTypeOptions = [],
  defaultSearchType
) {
  const usedTypes = new Set(filterRows.map((row) => row.searchType));

  return (
    searchTypeOptions.find((option) => !usedTypes.has(option.value))?.value ??
    defaultSearchType
  );
}

export function canAddMoreFilterRows(
  filterRows = [],
  searchTypeOptions = [],
  maxFilters = 4
) {
  return (
    filterRows.length < maxFilters &&
    filterRows.length < searchTypeOptions.length
  );
}

export function createFilterRow(searchType, value = "") {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    searchType,
    value,
  };
}
